import { Formik, Form } from 'formik';
import React, { Fragment } from 'react';

import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Divider, Grid } from '@mui/material';

import { TextField } from 'shared';
import { useCustomMediaQuery } from 'hooks/useMediaQuery';
import { allBanksUpdateFormStyles } from '../style/style';
import { nonQbAccountsInitialValues, nonQbAccountsSchema } from '../utils/nonQbBankAccountSchema';

const NonQbAccountsForm = ({ coas, accounts, loading, handleBlukAccountsUpdate }) => {
    const isMobileScreen = useCustomMediaQuery('(max-width:600px)');
    const classes = allBanksUpdateFormStyles({ isMobileScreen });

    const filterChangedAccounts = (updatedAccounts) => {
        return updatedAccounts.filter((updatedAccount, index) => {
            const initialAccount = accounts[index];
            return (
                updatedAccount.name !== initialAccount.official_name ||
                updatedAccount.mask !== initialAccount.mask
            );
        });
    };

    const handleFormSubmit = (values) => {
        const modifiedAccounts = filterChangedAccounts(values.accounts);
        handleBlukAccountsUpdate(modifiedAccounts);
    };

    const validateForm = (values) => {
        const errors = {};
        errors.accounts = [];

        const accountNumbers = values.accounts.map((account) => account.mask);

        const duplicateNumbers = accountNumbers.filter(
            (num, index) => num !== '' && accountNumbers.indexOf(num) !== index,
        );

        values.accounts.forEach((account, index) => {
            if (
                account.mask !== '' &&
                duplicateNumbers.includes(account.mask)
            ) {
                errors.accounts[index] = errors.accounts[index] || {};
                errors.accounts[index].mask = 'Mask number already exists';
            }
        });

        if (!errors.accounts.some((error) => error && Object.keys(error).length > 0)) {
            return {};
        }

        return errors;
    };

 

    return (
        <Formik
            onSubmit={handleFormSubmit}
            validationSchema={nonQbAccountsSchema}
            initialValues={nonQbAccountsInitialValues(accounts)}
            validate={validateForm}
        >
            {({ values, setFieldValue, errors, touched, isValid }) => (
                <Form>
                    <Box sx={classes.formWrapper}>
                        <Grid container spacing={{ xs: 1, md: 2 }}>
                            {values.accounts.map((account, index) => (
                                <Fragment key={account.id}>

                                    <Grid item xs={8} md={3}>
                                        <TextField
                                            fullWidth
                                            name={`accounts[${index}].name`}
                                            placeholder="Account Name"
                                            inlineLabel="Account Name"
                                            value={values.accounts[index].name}
                                            onChange={(e) =>
                                                setFieldValue(
                                                    `accounts[${index}].name`,
                                                    e.target.value,
                                                )
                                            }
                                            error={
                                                touched.accounts?.[index]?.name &&
                                                !!errors.accounts?.[index]?.name
                                            }
                                            helperText={
                                                touched.accounts?.[index]?.name &&
                                                errors.accounts?.[index]?.name
                                            }
                                        />
                                    </Grid>

                                    <Grid item xs={8} md={3}>
                                        <TextField
                                            fullWidth
                                            name={`accounts[${index}].mask`}
                                            placeholder="Mask Number"
                                            inlineLabel="Mask Number"
                                            value={values.accounts[index].mask}
                                            onChange={(e) =>
                                                setFieldValue(
                                                    `accounts[${index}].mask`,
                                                    e.target.value,
                                                )
                                            }
                                            error={
                                                touched.accounts?.[index]?.mask &&
                                                !!errors.accounts?.[index]?.mask
                                            }
                                            helperText={
                                                touched.accounts?.[index]?.mask &&
                                                errors.accounts?.[index]?.mask
                                            }
                                        />
                                    </Grid>


                                    {index !== accounts?.length - 1 && (
                                        <Grid item xs={12}>
                                            <Divider sx={classes.dividerBackground} />
                                        </Grid>
                                    )}
                                </Fragment>
                            ))}
                        </Grid>
                    </Box>

                    <Box
                        width="100%"
                        display="flex"
                        justifyContent="flex-end"
                        marginTop={isMobileScreen ? 1 : 3}
                        gap={2}
                    >
                        <LoadingButton
                            type="submit"
                            variant="contained"
                            color="primary"
                            loading={loading}
                            disabled={!isValid}
                        >
                            Update
                        </LoadingButton>
                    </Box>
                </Form>
            )}
        </Formik>
    );
};

export default NonQbAccountsForm;
